import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbanisonrentinbelgaum() {



    const cardData = {




keyword: "Urbania on Rent in Belgaum",

headingDescription: "Belgaum Taxi Service offers premium Force Urbania on rent in Belgaum for group travel, corporate transportation, family tours, wedding events, airport transfers, pilgrimage trips, and long-distance journeys. Force Urbania is an ideal luxury van option for travelers who need spacious seating, premium interiors, better comfort, and smooth travel for large groups. Whether you require Urbania for a one-day trip, multi-day tour, corporate event, destination wedding, or outstation journey, we provide well-maintained vehicles with experienced chauffeurs. Our Urbania rental service includes comfortable seating arrangements, ample luggage space, doorstep pickup, flexible booking options, transparent pricing, and 24/7 customer support. Belgaum Taxi Service provides Force Urbania rental services for destinations across Karnataka, Goa, Maharashtra, and nearby states, making group transportation convenient, safe, and comfortable for families, corporate teams, tourists, and event groups.",

topPlaces: [
  {
    title: "Mangalore",
    description: "Mangalore is a coastal city known for beaches, temples, cultural attractions, and educational institutions. Urbania rental is suitable for comfortable group travel to this coastal destination."
  },
  {
    title: "Coorg",
    description: "Coorg is a beautiful hill station famous for coffee estates, waterfalls, forests, and scenic landscapes. It is a preferred destination for family and group tours from Belgaum."
  },
  {
    title: "Mysore",
    description: "Mysore is known for royal heritage, Mysore Palace, Chamundi Hills, and cultural attractions. Large groups often prefer Force Urbania for sightseeing trips."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site featuring ancient temples, historical ruins, and unique landscapes, making it an ideal destination for heritage group tours."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, famous for Sai Baba Temple. Urbania rental provides comfortable transportation for family and religious groups."
  },
  {
    title: "Nashik",
    description: "Nashik is known for temples, vineyards, cultural attractions, and religious importance. It is a popular destination for group trips and pilgrimage tours."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a coastal getaway near Mumbai famous for beaches, forts, resorts, and peaceful surroundings. It is suitable for group vacations and weekend trips."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station known for waterfalls, caves, viewpoints, and green valleys. It is a comfortable road trip destination for groups."
  },
  {
    title: "Pune",
    description: "Pune is a major IT and business hub with historical attractions, educational institutions, and corporate destinations. Urbania is suitable for employee travel and group transportation."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, tourist attractions, and entertainment venues. Force Urbania provides premium group travel solutions to Mumbai."
  }
],




"services": [
  {
    "name": "Urbania on Rent in Belgaum",
    "description": "Book Urbania on Rent in Belgaum for luxury and comfortable group transportation services. Force Urbania is perfect for family trips, corporate travel, wedding functions, airport transfers, sightseeing tours, and outstation journeys. Enjoy premium interiors, spacious seating, AC comfort, professional drivers, luggage space, flexible rental packages, and safe travel experience with reliable booking support."
  },
  {
    "name": "Force Urbania on Rent in Belgaum",
    "description": "Hire Force Urbania on Rent in Belgaum for premium group travel with modern features, comfortable seats, and luxury travel experience. Ideal for corporate events, family vacations, wedding guest transportation, and long-distance travel with experienced chauffeurs and affordable rental options."
  },
  {
    "name": "Urbania Rent in Belgaum",
    "description": "Choose Urbania Rent in Belgaum for spacious and luxurious vehicle rental services. Our Force Urbania vehicles provide comfortable journeys for groups with professional drivers, AC facilities, flexible rental plans, and reliable transportation solutions."
  },
  {
    "name": "Urbania Rental Belgaum",
    "description": "Book Urbania Rental Belgaum for premium van rental services suitable for tours, events, business travel, and group transportation. Experience luxury seating, smooth rides, trained drivers, and customized rental packages for every travel requirement."
  },
  {
    "name": "Force Urbania Rental Belgaum",
    "description": "Get Force Urbania Rental Belgaum services for comfortable and stylish group travel. Our luxury Urbania vehicles are available for local trips, outstation journeys, corporate transportation, wedding travel, and sightseeing packages."
  },
  {
    "name": "Urbania Hire Belgaum",
    "description": "Hire Urbania Belgaum for safe and convenient transportation with premium vehicles and professional chauffeurs. Perfect for family tours, business meetings, airport transfers, and group travel across multiple destinations."
  },
  {
    "name": "Online Urbania Booking Belgaum",
    "description": "Complete Online Urbania Booking Belgaum easily with quick confirmation and flexible travel options. Book luxury Force Urbania vehicles for airport pickup, outstation trips, corporate travel, weddings, and special occasions."
  },
  {
    "name": "Luxury Urbania Rental Belgaum",
    "description": "Experience Luxury Urbania Rental Belgaum with premium interiors, comfortable seating, modern facilities, and professional driver services. Ideal for luxury group travel, corporate events, wedding functions, and holiday tours."
  },
  {
    "name": "AC Force Urbania Belgaum",
    "description": "Book AC Force Urbania Belgaum for comfortable travel in all weather conditions. Enjoy air-conditioned interiors, spacious seating, experienced drivers, and smooth transportation for local and outstation journeys."
  },
  {
    "name": "Urbania with Driver Belgaum",
    "description": "Hire Urbania with Driver Belgaum for stress-free group transportation. Our experienced chauffeurs provide safe driving, timely pickup, and comfortable journeys for business trips, family tours, and events."
  },
  {
    "name": "Urbania Cab Service Belgaum",
    "description": "Choose Urbania Cab Service Belgaum for luxury group cab solutions with spacious seating, AC comfort, professional drivers, and reliable transportation for local and outstation travel."
  },
  {
    "name": "Urbania Taxi Service Belgaum",
    "description": "Book Urbania Taxi Service Belgaum for premium travel experiences with luxury vehicles, comfortable interiors, and dependable chauffeur services for families, companies, and tourists."
  },
  {
    "name": "Urbania for Outstation Belgaum",
    "description": "Travel comfortably with Urbania for Outstation Belgaum services. Our luxury Force Urbania vehicles are perfect for long-distance journeys, group tours, family vacations, and corporate travel with safe and smooth rides."
  },
  {
    "name": "Urbania Round Trip Belgaum",
    "description": "Book Urbania Round Trip Belgaum for return journeys with flexible schedules, affordable packages, and premium travel comfort. Suitable for sightseeing, holiday trips, business travel, and group transportation."
  },
  {
    "name": "Urbania Tour Package Belgaum",
    "description": "Choose Urbania Tour Package Belgaum for customized sightseeing and holiday tours. Enjoy luxury group travel with professional drivers, comfortable seating, and convenient travel planning."
  },
  {
    "name": "Corporate Urbania Rental Belgaum",
    "description": "Book Corporate Urbania Rental Belgaum for employee transportation, business meetings, corporate events, and executive travel. Get reliable luxury vehicles with professional drivers and comfortable travel solutions."
  },
  {
    "name": "Wedding Urbania Rental Belgaum",
    "description": "Hire Wedding Urbania Rental Belgaum for comfortable guest transportation during wedding functions and celebrations. Provide your guests with luxury travel, spacious seating, punctual service, and premium comfort."
  },
  {
    "name": "Family Urbania Hire Belgaum",
    "description": "Choose Family Urbania Hire Belgaum for vacations, pilgrimages, and family outings. Travel together comfortably with spacious interiors, AC facilities, luggage space, and experienced chauffeurs."
  },
  {
    "name": "Tourist Urbania Belgaum",
    "description": "Book Tourist Urbania Belgaum for sightseeing tours and group travel. Enjoy luxury transportation with comfortable seating, professional drivers, and reliable service for exploring destinations."
  },
  {
    "name": "Premium Urbania Rental Belgaum",
    "description": "Experience Premium Urbania Rental Belgaum with luxury vehicles designed for comfortable group journeys. Perfect for corporate travel, weddings, airport transfers, and premium outstation trips."
  },
  {
    "name": "Best Urbania on Rent Belgaum",
    "description": "Choose Best Urbania on Rent Belgaum for luxury vehicles, affordable pricing, professional drivers, and dependable travel services. We provide customized transportation solutions for every occasion."
  },
  {
    "name": "Affordable Urbania Rental Belgaum",
    "description": "Get Affordable Urbania Rental Belgaum with competitive rates, premium comfort, and reliable chauffeur services. Perfect for families, groups, companies, and tourists looking for convenient transportation."
  },
  {
    "name": "Cheap Urbania Hire Belgaum",
    "description": "Book Cheap Urbania Hire Belgaum for budget-friendly luxury group travel without compromising comfort. Enjoy clean vehicles, experienced drivers, and flexible rental packages."
  },
  {
    "name": "Urbania Hire Near Me Belgaum",
    "description": "Find Urbania Hire Near Me Belgaum for quick and reliable luxury vehicle booking. Get comfortable Force Urbania vehicles with professional drivers for local trips, events, and outstation travel."
  },
  {
    "name": "Belgaum to Goa Urbania Bus",
    "description": "Book Belgaum to Goa Urbania Bus for comfortable group travel with luxury seating, AC facilities, experienced drivers, and safe highway journeys. Ideal for family tours and group vacations."
  },
  {
    "name": "Belgaum to Pune Urbania Bus",
    "description": "Travel with Belgaum to Pune Urbania Bus for premium group transportation. Enjoy spacious seating, professional chauffeurs, affordable packages, and comfortable long-distance travel."
  },
  {
    "name": "Belgaum to Mumbai Urbania Bus",
    "description": "Choose Belgaum to Mumbai Urbania Bus for luxury outstation travel with modern interiors, experienced drivers, and reliable transportation services for groups."
  },
  {
    "name": "Belgaum to Bangalore Urbania Bus",
    "description": "Book Belgaum to Bangalore Urbania Bus for comfortable city-to-city travel with premium seating, AC comfort, and professional chauffeur service."
  },
  {
    "name": "Belgaum to Hyderabad Urbania Bus",
    "description": "Hire Belgaum to Hyderabad Urbania Bus for safe and comfortable long-distance journeys with luxury facilities, experienced drivers, and flexible booking options."
  },
  {
    "name": "Belgaum to Kolhapur Urbania Bus",
    "description": "Book Belgaum to Kolhapur Urbania Bus for convenient group transportation with premium comfort, affordable pricing, and reliable travel service."
  },
  {
    "name": "Belgaum to Hubli Urbania Bus",
    "description": "Choose Belgaum to Hubli Urbania Bus for comfortable travel with luxury interiors, professional drivers, and safe transportation solutions."
  },
  {
    "name": "Belgaum to Mahabaleshwar Urbania Bus",
    "description": "Travel with Belgaum to Mahabaleshwar Urbania Bus for relaxing hill station trips with comfortable seating, experienced chauffeurs, and premium travel experience."
  },
  {
    "name": "Belgaum to Shirdi Urbania Bus",
    "description": "Book Belgaum to Shirdi Urbania Bus for comfortable pilgrimage travel with luxury seating, safe driving, and reliable group transportation."
  },
  {
    "name": "Belgaum Outstation Urbania Bus",
    "description": "Hire Belgaum Outstation Urbania Bus for premium long-distance travel. Perfect for family tours, corporate trips, weddings, and group vacations with luxury comfort."
  },
  {
    "name": "Force Urbania on Rent in Belagavi",
    "description": "Book Force Urbania on Rent in Belagavi for luxury group transportation with spacious seating, AC comfort, and professional drivers. Suitable for events, tours, corporate travel, and outstation trips."
  },
  {
    "name": "Urbania on Rent in Belagavi",
    "description": "Choose Urbania on Rent in Belagavi for premium travel solutions with comfortable interiors, flexible rental plans, and reliable chauffeur-driven services."
  },
  {
    "name": "13 Seater Urbania on Rent Belagavi",
    "description": "Book 13 Seater Urbania on Rent Belagavi for small group travel, family trips, corporate transportation, and sightseeing tours with luxury seating and comfortable rides."
  },
  {
    "name": "17 Seater Urbania on Rent Belagavi",
    "description": "Hire 17 Seater Urbania on Rent Belagavi for large group transportation with premium interiors, AC facilities, experienced drivers, and affordable rental packages."
  },
  {
    "name": "Luxury Force Urbania Rental Belagavi",
    "description": "Experience Luxury Force Urbania Rental Belagavi with premium vehicles, modern comfort features, and professional chauffeur services for special occasions and long-distance travel."
  },
  {
    "name": "Urbania Cab Service Belagavi",
    "description": "Book Urbania Cab Service Belagavi for reliable luxury transportation with comfortable vehicles and professional drivers for local and outstation journeys."
  },
  {
    "name": "Urbania Airport Transfer Belagavi",
    "description": "Choose Urbania Airport Transfer Belagavi for convenient airport pickup and drop services. Enjoy timely transportation, luggage space, AC comfort, and luxury group travel."
  },
  {
    "name": "Urbania Outstation Rental Belagavi",
    "description": "Book Urbania Outstation Rental Belagavi for premium long-distance travel with luxury Force Urbania vehicles, professional chauffeurs, comfortable seating, and reliable service."
  }
],

"tableData": [
  ["Urbania on Rent in Belgaum", "Force Urbania on Rent in Belgaum"],
  ["Urbania Rent in Belgaum", "Urbania Rental Belgaum"],
  ["Force Urbania Rental Belgaum", "Urbania Hire Belgaum"],
  ["Online Urbania Booking Belgaum", "Luxury Urbania Rental Belgaum"],
  ["AC Force Urbania Belgaum", "Urbania with Driver Belgaum"],
  ["Urbania Cab Service Belgaum", "Urbania Taxi Service Belgaum"],
  ["Urbania for Outstation Belgaum", "Urbania Round Trip Belgaum"],
  ["Urbania Tour Package Belgaum", "Corporate Urbania Rental Belgaum"],
  ["Wedding Urbania Rental Belgaum", "Family Urbania Hire Belgaum"],
  ["Tourist Urbania Belgaum", "Premium Urbania Rental Belgaum"],
  ["Best Urbania on Rent Belgaum", "Affordable Urbania Rental Belgaum"],
  ["Cheap Urbania Hire Belgaum", "Urbania Hire Near Me Belgaum"],
  ["Belgaum to Goa Urbania Bus", "Belgaum to Pune Urbania Bus"],
  ["Belgaum to Mumbai Urbania Bus", "Belgaum to Bangalore Urbania Bus"],
  ["Belgaum to Hyderabad Urbania Bus", "Belgaum Outstation Urbania Bus"],
  ["13 Seater Urbania on Rent Belagavi", "17 Seater Urbania on Rent Belagavi"],
  ["Urbania Airport Transfer Belagavi", "Urbania Outstation Rental Belagavi"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Urbania on Rent in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service provides luxury Force Urbania rentals for group travel, corporate events, family tours, weddings, and comfortable long-distance journeys."
  },
  {
    WhyChooseheading: "Luxury & Spacious Travel Experience",
    WhyChoosedescription: "Force Urbania offers premium interiors, comfortable seating, powerful air conditioning, and ample luggage space for a relaxed group travel experience."
  },
  {
    WhyChooseheading: "Multiple Seating Capacity Options",
    WhyChoosedescription: "Choose Urbania vehicles based on your group size with comfortable seating arrangements suitable for family trips, corporate teams, and large groups."
  },
  {
    WhyChooseheading: "Perfect for Outstation & Group Trips",
    WhyChoosedescription: "Hire Urbania for Goa trips, Bangalore travel, Pune journeys, Mumbai tours, pilgrimage tours, corporate outings, and multi-day vacations."
  },
  {
    WhyChooseheading: "Professional Driver Assistance",
    WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, smooth highway travel, punctual service, and a comfortable journey for every passenger."
  },
  {
    WhyChooseheading: "Pickup Available Across Belgaum",
    WhyChoosedescription: "Get convenient pickup from Belgaum Airport, Railway Station, hotels, offices, homes, and preferred locations with flexible travel planning."
  },
  {
    WhyChooseheading: "Affordable Urbania Rental Packages",
    WhyChoosedescription: "Choose hourly, daily, one-way, and multi-day Urbania rental packages with transparent pricing and reliable service."
  },
  {
    WhyChooseheading: "24/7 Booking Support",
    WhyChooseheading: "24/7 Booking Support",
    WhyChoosedescription: "Book your Force Urbania rental anytime with quick confirmation and dedicated customer assistance for hassle-free group transportation."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Urbania on Rent in Belgaum?",
    answer: "Yes, we provide Force Urbania rental services in Belgaum for corporate travel, family trips, weddings, group tours, and outstation journeys."
  },
  {
    question: "What is Force Urbania suitable for?",
    answer: "Force Urbania is ideal for luxury group travel, corporate outings, airport transfers, family vacations, wedding transportation, and long-distance trips."
  },
  {
    question: "How many passengers can travel in Urbania?",
    answer: "Force Urbania is available in different seating configurations suitable for small and large groups."
  },
  {
    question: "Can I hire Urbania for outstation trips from Belgaum?",
    answer: "Yes, Urbania rental is available for destinations like Goa, Bangalore, Pune, Mumbai, Kerala, and other major routes."
  },
  {
    question: "Is Urbania available for corporate travel?",
    answer: "Yes, Urbania is an excellent choice for corporate events, employee transportation, business meetings, and executive group travel."
  },
  {
    question: "Can I book Urbania for wedding guest transportation?",
    answer: "Yes, Urbania rentals are available for weddings, guest transfers, functions, and special occasions."
  },
  {
    question: "Does Urbania rental include a driver?",
    answer: "Yes, professional and experienced drivers are provided to ensure safe and comfortable travel."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, permits, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Is Urbania rental available 24/7 in Belgaum?",
    answer: "Yes, our Urbania rental service is available 24 hours a day for planned and urgent travel requirements."
  },
  {
    question: "How can I book an Urbania on Rent in Belgaum?",
    answer: "Share your travel date, pickup location, destination, passenger count, and trip details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Patil",
    feedback: "We hired Force Urbania for our family tour from Belgaum. The vehicle was luxurious, spacious, and the driver provided excellent service throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Desai",
    feedback: "Our corporate group travel experience was excellent. The Urbania was comfortable, clean, and perfect for a long-distance journey with multiple passengers.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/urbania-on-rent-in-belgaum.webp",
  "description":
    "Book Urbania On Rent in Belgaum with Belgaum Taxi Service for luxury group travel and premium van rental services. We provide Force Urbania rentals for corporate events, family trips, weddings, airport transfers, and outstation journeys with AC Urbania vehicles and professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/urbania-on-rent-in-belgaum"
  }
};






    return (
        <div>

<Helmet>
  <title>Urbania On Rent in Belgaum | Force Urbania Rental | +91 8722158435</title>

  <meta
    name="description"
    content="Book Urbania On Rent in Belgaum with Belgaum Taxi Service for luxury and comfortable group transportation. Hire Force Urbania for corporate events, weddings, family tours, airport transfers, and outstation trips with AC Urbania and professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Belgaum, Force Urbania on Rent in Belgaum, Urbania Rent in Belgaum, Urbania Rental Belgaum, Force Urbania Rental Belgaum, Urbania Hire Belgaum, Online Urbania Booking Belgaum, Luxury Urbania Rental Belgaum, AC Force Urbania Belgaum, Urbania with Driver Belgaum, Urbania Cab Service Belgaum, Urbania Taxi Service Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbanisonrentinbelgaum;